<template>
  <div class="c-instantwin-random text-primary mb-5">
    <!-- STEP 0 -->
    <GreetingMission
      :title="$t('Prova a vincere')"
      :description="$t('Scopri se sei uno dei fortunati a vincere il premio')"
      @action="moveToNextStep"
      v-if="currentStep === 0"
    >
      <div class="c-instantwin-random__slot">
        <div class="c-instantwin-random__slot__desc">
          {{ $t("Ci sono in palio") }}
        </div>
        <div class="c-instantwin-random__slot__reward">
          {{ mission.data.points }} {{ $t("coins") }}
        </div>
      </div>
    </GreetingMission>
    <!-- STEP 0 END -->
    <!-- STEP 1 -->
    <div class="container" v-if="currentStep === 1">
      <div class="c-instantwin-random__step-1">
        <div v-if="!isDesktop">
          <router-link to="/dashboard">
            <div
              class="c-instantwin-random__step-1__close"
              v-html="closeIcon"
            ></div>
          </router-link>
          <div class="c-instantwin-random__step-1__category">
            {{ $t("InstantWin") }}
          </div>
        </div>
        <div class="c-instantwin-random__step-1__title">
          <!-- {{ mission.data.title }} -->
          {{ $t("Scopri se hai vinto") }}
        </div>
        <button
          v-show="isBtnVisible"
          @click="playWaitingLottie"
          class="c-instantwin-random__step-1__btn btn-primary"
        >
          {{ $t("Gioca") }}
        </button>

        <!-- WAITING ANIMATION -->
        <Lottie
          v-show="isLottieWaitingVisible"
          :options="lottieWaitingOptions"
          :height="400"
          :width="400"
          @animCreated="handleWaitCreated"
        ></Lottie>

        <div
          class="c-instantwin-random__step-1__lottie-end"
          v-show="isLottieWaitingEnd"
        >
          <!-- WIN ANIMATION -->
          <Lottie
            v-show="isWon"
            :options="lottieWinOptions"
            :height="400"
            :width="400"
            @animCreated="handleWonCreated"
          ></Lottie>

          <!-- LOSE ANIMATION -->
          <Lottie
            v-show="!isWon"
            :options="lottieLoseOptions"
            :height="400"
            :width="400"
            @animCreated="handleLoseCreated"
          ></Lottie>

          <router-link
            to="/dashboard"
            class="c-instantwin-random__step-1__redirect"
          >
            <button class="c-instantwin-random__step-1__btn btn-primary mt-5">
              {{ $t("Torna alla home") }}
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- STEP 1 END -->
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import GreetingMission from "@/components/rebuild/common/GreetingMission";

import closeIcon from "@/assets/svg/rebuild/close.svg";
import * as lose from "@/assets/lottie/lose.json";
import * as waiting from "@/assets/lottie/waiting.json";
import * as win from "@/assets/lottie/win.json";

import { Actions, Mutations } from "@/store/global/global.types";
import { mapGetters } from "vuex";
import { MissionService } from "@/common/services/api.service";

const sleep = m => new Promise(r => setTimeout(r, m));

export default {
  name: "InstantwinRandom",
  components: {
    Lottie,
    GreetingMission
  },
  computed: {
    ...mapGetters(["getUserTasks", "isDesktop"])
  },
  data() {
    return {
      currentStep: 0,
      lottieWaitingOptions: {
        animationData: waiting.default,
        loop: true,
        autoplay: false
      },
      lottieWinOptions: {
        animationData: win.default,
        loop: true,
        autoplay: false
      },
      lottieLoseOptions: {
        animationData: lose.default,
        loop: true,
        autoplay: false
      },
      mission: { data: {} },
      closeIcon,
      isLottieWaitingVisible: false,
      isLottieWaitingEnd: false,
      isWon: false,
      isBtnVisible: true
    };
  },
  async mounted() {
    if (!this.getUserTasks.length) {
      this.$store.commit(Mutations.SHOW_SPINNER);
      await this.$store.dispatch(Actions.GET_USER_TASKS);
      this.$store.commit(Mutations.HIDE_SPINNER);
    }
    this.mission = this.getUserTasks.find(
      el => el.data.id === this.$route.params.id
    ) || { data: {} };

    if (!Object.keys(this.mission.data).length) {
      this.$router.push("/dashboard");
    }
  },
  methods: {
    moveToNextStep() {
      this.currentStep++;
    },
    handleWaitCreated: function(waitLottieRef) {
      this.waitLottieRef = waitLottieRef;
    },
    handleLoseCreated(lostLottieRef) {
      this.lostLottieRef = lostLottieRef;
    },
    handleWonCreated(wonLottieRef) {
      this.wonLottieRef = wonLottieRef;
    },
    async playWaitingLottie() {
      this.isBtnVisible = false;
      this.isLottieWaitingVisible = true;
      this.waitLottieRef.animationData = win.default;
      this.waitLottieRef.play();
      //TODO : add try catch
      const res = await MissionService.playInstantwinRandom(
        this.$route.params.id
      );
      await sleep(1500);
      this.isLottieWaitingVisible = false;
      this.waitLottieRef.stop();
      this.isLottieWaitingEnd = true;
      if (res.data.data.won) {
        this.wonLottieRef.play();
        this.isWon = true;
      } else {
        this.lostLottieRef.play();
        this.isWon = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-instantwin-random__slot {
  margin-top: 40px;
  font-weight: 600;
}
.c-instantwin-random__slot__reward {
  font-weight: 800;
}
.c-instantwin-random__step-1 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.c-instantwin-random__step-1__category {
  margin-top: 27px;
}
.c-instantwin-random__step-1__close {
  position: absolute;
  right: 25px;
  top: 30px;
}
.c-instantwin-random__step-1__title {
  font-weight: bold;
  font-size: 30px;
  margin: 40px 0;
}
.c-instantwin-random__step-1__btn {
  color: #fff;
  padding: 10px 40px;
  border-radius: 10px;
  font-weight: 500;
  margin-top: 100px;
}
.c-instantwin-random__step-1__redirect {
  display: flex;
  justify-content: center;
}
</style>
